import { apolloClient } from "@/plugins/vue-apollo.js";

const updateLandmark = async (_variables) => {
    // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/landmark/update_landmark.graphql"),
      variables: variables,
      
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/landmark/get_landmark_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            }
            // ,
            // filter: {
            //   searchKey: ''
            // }
          },
        };
        let allLandmarks = store.readQuery(query);
        // debugger
        const findIndex = allLandmarks.getLandmark.landmarks.findIndex(
          (item) => item._id === data.updateLandmark._id
        );
        findIndex !== -1 &&
          allLandmarks.getLandmark.landmarks.splice(
            findIndex,
            1,
            data.updateLandmark
          );
        store.writeQuery({
          ...query,
          data: allLandmarks,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updateLandmark };
